export default __webpack_public_path__ + "static/media/Spin general_Interactive LightMix0035.21a4f540.webp";